<template>
    <div class="layout">
        <div class="layout__header">
            <div class="layout__title">
                <h3>Consulta ECAS</h3>
            </div>
            <div class="layout__controls">
                <div class="form-inline">
                    <button v-show="puedeEditar || puedeEliminar || puedeConsultar" class="btn-info" type="button" @click="consultar"><i class="fa fa-search"></i><span>Consultar</span></button>
                    <button v-show="puedeCrear" @click="agregar" class="btn-success" type="button">
                        <i class="fa fa-plus"></i><span>Nuevo</span>
                    </button>
                </div>
            </div>
        </div>
        <div class="card">
            <div class="card__title">
                <h5>Filtros de la consulta</h5>
            </div>
            <div class="card__content">
                <div class="row">
                    <div class="col-xs-12">
                        <div class="form-inline">
                            <label for="hoy">
                                <input v-model="form.tipo_fecha" type="radio" name="tipo_fecha" id="hoy" value="H"> <span>Hoy</span>
                            </label>
                            <label for="ayer">
                                <input v-model="form.tipo_fecha" type="radio" name="tipo_fecha" id="ayer" value="A"> <span>Ayer</span>
                            </label>
                            <label for="personalizado">
                                <input @change="changePersonalizado" value="P" v-model="form.tipo_fecha" type="radio" name="tipo_fecha" id="personalizado"> <span>Personalizado</span>
                            </label>
                            <div v-show="form.tipo_fecha === 'P'" class="form-field">
                                <div class="datepicker-field datepicker-field--stretch">
                                    <date-picker @enterkey="consultar" type="date" id="desde" v-model="form.desde"></date-picker>
                                    <label>{{ $t('message.desde') }}</label>
                                    <span v-if="errores.desde" class="helper-text text-danger" slot="helper">
                                        <strong>{{ errores.desde[0] }}</strong>
                                    </span>
                                </div>
                            </div>
                            <div v-show="form.tipo_fecha === 'P'" class="form-field">
                                <div class="datepicker-field datepicker-field--stretch">
                                    <date-picker @enterkey="consultar" type="hasta" id="hasta" v-model="form.hasta"></date-picker>
                                    <label>{{ $t('message.hasta') }}</label>
                                    <span v-if="errores.hasta" class="helper-text text-danger" slot="helper">
                                        <strong>{{ errores.hasta[0] }}</strong>
                                    </span>
                                </div>
                            </div>
                            <div v-show="lineas.length > 1" class="col-xs-12 col-md-4">
                                <div class="form-field select2">
                                    <div class="select2-field">
                                        <v-select @input="inputLinea" :options="lineas" label="name" id="linea" placeholder="Seleccione..." v-model="selectedLinea"></v-select>
                                        <label for="linea">Línea</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card">
            <div class="card__title">
                <h5>Resultados de la consulta</h5>
            </div>
            <div class="card__content">
                <tabs :options="{ defaultTabHash: 'procesados' }" @changed="tabChanged">
                    <div class="form-field">
                        <input-field @keyup.enter="consultar" id="search" placeholder="Consultar..." v-model="form.buscar"></input-field>
                    </div>
                    <tab id="procesados" name="Procesados">
                        <div class="table-responsive">
                            <k-table 
                                :buttons="[
                                    {
                                        class : 'btn-info',
                                        icon : 'fa-edit',
                                        event : 'editar'
                                    },
                                    {
                                        class : 'btn-secondary',
                                        icon : 'fa-file',
                                        event : 'verLogs'
                                    },
                                    {
                                        class : 'btn-danger',
                                        icon : 'fa-trash',
                                        event : 'eliminar'
                                    }
                                ]"
                                @verLogs="verLogs"
                                @editar="editar"
                                @eliminar="eliminar"
                                noForms
                                :params="form"
                                :mostrarTodos="false"
                                :columns="[
                                    {
                                        display : 'Fecha de emisión',
                                        value : 'fecha_emision'
                                    },
                                    {
                                        display : 'Nº Oficio',
                                        value : 'oficio_no'
                                    },
                                    {
                                        display : 'Marca',
                                        value : 'marca'
                                    },
                                    {
                                        display: 'Nave',
                                        value: 'nave'
                                    },
                                    {
                                        display: 'Viaje',
                                        value: 'viaje'
                                    },
                                    {
                                        display: 'Embarque',
                                        value: 'embarque'
                                    },
                                    {
                                        display: 'Línea',
                                        value: 'linea'
                                    },
                                    {
                                        display: 'A. Nave',
                                        value: 'arriba_nave'
                                    },
                                    {
                                        display : 'Importador',
                                        value : 'importador'
                                    },
                                    {
                                        display : 'Contenedor',
                                        value : 'contenedor'
                                    },
                                    {
                                        display : 'Tipo de contenedor',
                                        value : 'tipo_contenedor'
                                    },
                                    {
                                        display : 'Fecha de inicio',
                                        value : 'fecha_inicio'
                                    },
                                    {
                                        display : 'Fecha de caducidad',
                                        value : 'fecha_caducidad'
                                    },
                                    {
                                        display : 'Procesamiento',
                                        value : 'fecha_procesamiento'
                                    },
                                    {
                                        display : 'Fichero',
                                        value : 'kim_path'
                                    }
                                ]"
                                :path="path"
                                ref="consultaEcas"
                                :deleteButton="false" 
                                :createButton="false" 
                                :editButton="false">
                            </k-table>
                        </div>
                    </tab>
                    <tab id="no-procesados" name="No procesados">
                        <div class="table-responsive">
                            <k-table 
                                :buttons="[
                                    {
                                        class : 'btn-info btn--text',
                                        icon : 'fa-eye',
                                        event : 'verNoProcesado'
                                    }
                                ]"
                                @verNoProcesado="verNoProcesado"
                                noForms
                                :params="form"
                                :mostrarTodos="false"
                                :columns="[
                                    {
                                        display : 'Fichero',
                                        value : 'path'
                                    },
                                    {
                                        display : 'Fecha',
                                        value : 'created_at'
                                    }
                                ]"
                                :path="path"
                                ref="consultaProcesados"
                                :deleteButton="false" 
                                :createButton="false" 
                                :editButton="false"></k-table>
                        </div>
                    </tab>
                </tabs>
            </div>
        </div>
        <modal :clickToClose="false" name="ecas" scrollable height="auto" width="85%">
            <ecas :yards="yards" @saved="saved" :tipoFormulario="tipoFormulario" :lineas="lineas" @cancelar="cancelarEcas" :tiposContenedor="tiposContenedor" :naves="naves" 
            :telefonos="telefonos"
            v-model="currentEcas"></ecas>
        </modal>
        <modal :clickToClose="false" name="logs" scrollable height="auto" width="65%">
            <log-no-procesados @procesado="procesado" @cerrar="$modal.hide('logs');" :path="currentPath"></log-no-procesados>
        </modal>
        <modal name="logsEcasCoparn" scrollable height="auto" width="65%">
            <logs-ecas-coparn @cerrar="$modal.hide('logsEcasCoparn')" :id="currentId"></logs-ecas-coparn>
        </modal>
    </div>
</template>

<script>
export default {
    props : {
        puedeEditarAdmin : {
            type : Boolean,
            required : false,
            default : false
        },
        puedeEliminarAdmin : {
            type : Boolean,
            required : false,
            default : false
        },
        tiposContenedor : {
            type : Array,
            required : false,
            default : function () {
                return [];
            }
        },
        naves : {
            type : Array,
            required : false,
            default : function () {
                return [];
            }
        },
        rucs : {
            type : Array,
            required : false,
            default : function () {
                return [];
            }
        },
        telefonos : {
            type : Array,
            required : false,
            default : function () {
                return [];
            }
        },
        lineas : {
            type : Array,
            required : false,
            default : function () {
                return [];
            }
        },
        yards : {
            type : Array,
            required : false,
            default : function () {
                return [];
            }
        },
        puedeConsultar : {
            type : Boolean,
            required : false,
            default : false
        },
        puedeCrear : {
            type : Boolean,
            required : false,
            default : false
        },
        puedeEditar : {
            type : Boolean,
            required : false,
            default : false
        },
        puedeEliminar : {
            type : Boolean,
            required : false,
            default : false
        }
    },
    data : function () {
        return {
            registros : [],
            form : {
                linea_id: '',
                buscar : '',
                tipo_fecha : 'H',
                desde : moment(new Date()).format('YYYY-MM-DD'),
                hasta : moment(new Date()).format('YYYY-MM-DD'),
                tipo_consulta : 'P'
            },
            errores : {},
            tipoFormulario : 'N',
            moment : moment,
            currentPath : '',
            currentId : '',
            path : url + '/ecas',
            selectedLinea: null,
            currentEcas: null
        };
    },
    methods : {
        inputLinea: function () {
            if (this.selectedLinea !== null)
                this.form.linea_id = this.selectedLinea.code;
            else 
                this.form.linea_id = '';
        },
        tabChanged : function (tab) {
            if (tab.tab.id == 'procesados')
                this.form.tipo_consulta = 'P';
            else 
                this.form.tipo_consulta = 'N';
            this.consultar();
        },
        verLogs : function (row) {
            this.currentId = row.kim_id;
            this.$modal.show('logsEcasCoparn');
        },
        procesado : function () {
            this.currentPath  = '';
            this.$modal.hide('logs');
            this.consultar();
        },
        verNoProcesado : function (ecas) {
            this.currentPath  = ecas.path;
            this.$modal.show('logs');
        },
        changePersonalizado : function () {
            let today = new Date();
            let desde = new Date();
            desde.setDate(desde.getDate() - 7);
            this.form.desde = moment(desde).format('YYYY-MM-DD');
            this.form.hasta = moment(today).format('YYYY-MM-DD');
        },
        saved : function () {
            this.tipoFormulario = 'N';
            this.$modal.hide('ecas');
            this.consultar();
        },
        cancelarEcas : function () {
            this.tipoFormulario = 'N';
            this.$modal.hide('ecas');
        },
        editar : function (ecas) {
            if (this.puedeEditarAdmin || ecas.kim_path === null) {
                this.tipoFormulario = 'E';
                this.currentEcas = {
                    numero_oficio : ecas.oficio_no,
                    fecha_emision : moment(ecas.fecha_emision).format('YYYY-MM-DD'),
                    nave : ecas.nave,
                    viaje : ecas.viaje,
                    embarque : ecas.embarque, 
                    linea : ecas.linea,
                    arriva_nave : moment(ecas.arriba_nave).format('YYYY-MM-DD'),
                    mrn : ecas.mrn, 
                    bl : ecas.bl, 
                    importador : ecas.importador, 
                    ruc_importador : ecas.ruc_importador, 
                    tel_importador : ecas.tel_importador, 
                    contenedor : ecas.contenedor,
                    tipo_contenedor : ecas.codigo_tipo_contenedor, 
                    fecha_inicio : moment(ecas.fecha_inicio).format('YYYY-MM-DD'),
                    fecha_caducidad : moment(ecas.fecha_caducidad).format('YYYY-MM-DD'),
                    sello : ecas.sello,
                    linea_id : ecas.linea,
                    size : ecas.size,
                    yard_code : ecas.yard_code,
                    marca : ecas.marca
                };
                this.$modal.show('ecas');
            }
            else 
                swal('No puede editarse este registro ya que fue ingresado por proceso automático.', 'Aviso', 'warning');
        },
        eliminar : function (ecas) {
            if (this.puedeEliminarAdmin || ecas.kim_path === null) {
                let that = this;
                swal({
                    title: '¿Desea eliminar el ecas seleccionado?',
                    type: 'question',
                    showCancelButton: true,
                    confirmButtonText: 'Aceptar',
                    cancelButtonText : 'Cancelar'
                    }).then((result) => {
                        if (result.value) {
                            axios.post(url + '/ecas' + '/' + ecas.contenedor, {
                                _method : 'DELETE',
                                numero_oficio : ecas.oficio_no
                            }).then(function (response) {
                                swal('El ecas fue eliminado.', 'Realizado', 'success');
                                that.consultar();
                            }).catch(function (error) {
                                if (error !== null && error !== undefined) {
                                    let response = error.response;
                                    if (response !== undefined && response !== null) {
                                        let status = response.status;
                                        if (status === 422) 
                                        {
                                            that.errores = response.data.errors;
                                            swal('Hay errores en el formulario.', 'Aviso', 'warning');
                                            return;
                                        }
                                    }
                                }
                                swal('Hubo un error, intente nuevamente.', 'Error', 'error');
                            });
                        }
                    });
            }
            else    
                swal('No puede eliminarse este registro ya que fue ingresado por proceso automático.', 'Aviso', 'warning');
        },
        agregar : function () {
            this.tipoFormulario = 'N';
            this.currentEcas = {
                numero_oficio : '',
                fecha_emision : moment(new Date()).format('YYYY-MM-DD'),
                nave : '',
                viaje : '',
                embarque : '', 
                linea : '',
                arriva_nave : moment(new Date()).format('YYYY-MM-DD'),
                mrn : '', 
                bl : '', 
                importador : '', 
                ruc_importador : '', 
                tel_importador : '', 
                contenedor : '',
                tipo_contenedor : '', 
                fecha_inicio : moment(new Date()).format('YYYY-MM-DD'),
                fecha_caducidad : moment(new Date()).format('YYYY-MM-DD'),
                sello : '',
                linea_id : '',
                size : '4',
                yard_code : '',
                marca : ''
            };
            this.$modal.show('ecas');
        },
        consultar : function () {
            if (this.puedeEditar || this.puedeEliminar || this.puedeConsultar) {
                if (this.form.tipo_consulta == 'P')
                    this.$refs.consultaEcas.loadRows();
                else
                    this.$refs.consultaProcesados.loadRows();
            }
        }
    },
    mounted : function () {
        this.changePersonalizado();
        this.consultar();
    }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/ecas-coparn/ConsultaEcas.vue